
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internal-txs",
      function () {
        return require("private-next-pages/internal-txs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internal-txs"])
      });
    }
  